import Text from "aldoo-ra/Text"

export default function Copyright() {
  // Footer background is always dark — keep the text readable in white.
  const text = "text-white/60"
  const link = "text-white/80 hover:text-white"

  return (
    <Text
      id="site_copyright"
      variant="txt1_dim"
      className={text}
      data={{
        product: (
          <a
            key="product-home"
            href="/"
            className={`${link} transition-colors duration-700`}
          >
            Aldoo Transfer
          </a>
        ),
        year: new Date().getFullYear(),
      }}
    />
  )
}
